import api from '../../../services/api';
import {
  User,
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  RegisterResponse,
  RefreshTokenResponse,
  UserUpdateData,
  ApiResponse,
} from '@kifuerpflege/shared';

/**
 * Register a new user
 */
export async function register(data: RegisterRequest, turnstileToken?: string): Promise<RegisterResponse> {
  const response = await api.post<ApiResponse<RegisterResponse>>(
    '/auth/register',
    { ...data, turnstileToken }
  );

  return response.data.data!;
}

/**
 * Login user
 */
export async function login(data: LoginRequest, turnstileToken?: string): Promise<AuthResponse> {
  const response = await api.post<ApiResponse<AuthResponse>>('/auth/login', { ...data, turnstileToken });

  return response.data.data!;
}

/**
 * Refresh access token
 */
export async function refreshToken(
  refreshToken: string
): Promise<RefreshTokenResponse> {
  const response = await api.post<ApiResponse<RefreshTokenResponse>>(
    '/auth/refresh',
    { refreshToken }
  );

  return response.data.data!;
}

/**
 * Logout user
 */
export async function logout(refreshToken?: string): Promise<void> {
  await api.post('/auth/logout', { refreshToken });
}

/**
 * Get current user
 */
export async function getCurrentUser(): Promise<User> {
  const response = await api.get<ApiResponse<User>>('/auth/me');

  return response.data.data!;
}

/**
 * Update current user
 */
export async function updateCurrentUser(data: UserUpdateData): Promise<User> {
  const response = await api.patch<ApiResponse<User>>('/auth/me', data);

  return response.data.data!;
}

/**
 * Change password
 */
export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await api.post('/auth/change-password', { currentPassword, newPassword });
}

/**
 * Delete account
 */
export async function deleteAccount(password: string): Promise<void> {
  await api.delete('/auth/me', { data: { password } });
}

/**
 * Request password reset
 */
export async function forgotPassword(email: string): Promise<string> {
  const response = await api.post<ApiResponse<{ message: string }>>('/auth/forgot-password', { email });
  return response.data.data!.message;
}

/**
 * Reset password with token
 */
export async function resetPassword(token: string, newPassword: string): Promise<string> {
  const response = await api.post<ApiResponse<{ message: string }>>('/auth/reset-password', { token, newPassword });
  return response.data.data!.message;
}

/**
 * Verify email with token
 */
export async function verifyEmail(token: string): Promise<string> {
  const response = await api.post<ApiResponse<{ message: string }>>('/auth/verify-email', { token });
  return response.data.data!.message;
}

/**
 * Resend verification email
 */
export async function resendVerificationEmail(email: string): Promise<string> {
  const response = await api.post<ApiResponse<{ message: string }>>('/auth/resend-verification', { email });
  return response.data.data!.message;
}
